export const permitType = [
  {
    itemValue: 'CHARTER_PERMIT',
    itemLabel: 'CHARTER PERMIT',
  },
  {
    itemValue: 'ENTRY_PERMIT',
    itemLabel: 'ENTRY PERMIT',
  },
  {
    itemValue: 'LANDING_PERMIT',
    itemLabel: 'LANDING PERMIT',
  },
  {
    itemValue: 'OVERFLIGHT_PERMIT',
    itemLabel: 'OVERFLIGHT PERMIT',
  },
];

export const permitPaymentMethod = [
  {
    itemValue: 'CREDIT_CARD',
    itemLabel: 'CC',
  },
  {
    itemValue: 'WIRE_TRANSFER',
    itemLabel: 'WT',
  },
];

export const valueTypes = [
  {
    itemValue: 'PERCENTAGE',
    itemLabel: '%',
  },
  {
    itemValue: 'AMOUNT',
    itemLabel: '$',
  },
];
